import React from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'

import { COMING_SOON_BASE } from '../components/layout/Sidebar/futureNav'

const ComingSoon = React.lazy(() => import('../pages/ComingSoon/ComingSoon'))

/** The page every "Soon" sidebar link opens. Staff only, guarded the same way as /settings. */
export const getComingSoonRoutes = (loggedIn: boolean, loginRedirect: string): RouteObject[] => [
    {
        path: `${COMING_SOON_BASE}/:id`,
        element: loggedIn ? <ComingSoon /> : <Navigate to={loginRedirect} replace />,
    },
]
